<template>
  <div>
    <ts-page-title
      :title="$t('monthlyOvertime.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('monthlyOvertime.pageTitle'),
          active: true
        }
      ]"
    />
    <ts-card>
      <ts-card-wrapper class="ts-flex ts-items-center ts-justify-between">
        <div>
          <Button type="info" ghost @click="addNew">{{
            $t('addNew')
          }}</Button>
        </div>
        <div class="ts-flex ts-space-x-2">
          <div>
            <DatePicker
              type="year"
              format="yyyy"
              placeholder="Select Year"
              @on-change="onChangeYear"
              :value="year"
            ></DatePicker>
          </div>
          <div>
            <DatePicker
              type="month"
              format="MM"
              placeholder="Select Month"
              @on-change="onChangeMonth"
              :value="month"
            >
            </DatePicker>
          </div>
          <div>
            <Input
              v-model="search"
              search
              :placeholder="$t('monthlyOvertime.searchEmployee')"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        :loading="loading"
        highlight-row 
        stripe
        max-height="700"
      ></Table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
      <a-modal
        v-model="showForm"
        :z-index="1022"
        centered
        :zIndex="1020"
        :footer="null"
        width="800px"
        :title="$t('monthlyOvertime.pageTitle')"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>
<script>
import FromAction from './form.vue'
import moment from 'moment'
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'monthly-over-time',
  components: {
    FromAction
  },
  data () {
    return {
      loading: false,
      width: 'width: 300px',
      showForm: false,
      year: moment().format('YYYY'),
      month: moment().format('MM')
    }
  },
  computed: {
    ...mapState('payroll/monthlyOvertime', ['resources', 'pagination']),

    search: {
      get () {
        return this.$store.state.payroll.monthlyOvertime.search
      },
      set (newValue) {
        this.$store.commit('payroll/monthlyOvertime/SET_SEARCH', newValue)
        this.$store.commit('payroll/monthlyOvertime/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          title: this.$t('monthlyOvertime.employeeName'),
          slot: 'employee_name_en',
          sortable: true
        },
        {
          title: this.$t('monthlyOvertime.otDate'),
          key: 'ot_date',
          sortable: true
        },
        {
          title: this.$t('monthlyOvertime.timeFrom'),
          key: 'time_from',
          sortable: true
        },
        {
          title: this.$t('monthlyOvertime.timeTo'),
          key: 'time_to',
          sortable: true
        },
        {
          title: this.$t('monthlyOvertime.break'),
          key: 'break',
          sortable: true
        },
        {
          title: this.$t('monthlyOvertime.remark'),
          key: 'remarks',
          sortable: true
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          align: 'center',
          fixed: 'right',
          className: 'tw-space-x-2',
          width: 90
        }
      ]
    }
  },
  methods: {
    addNew () {
      this.showForm = true
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('payroll/monthlyOvertime/fetch', attributes)
        .catch(error => {
          this.loading = false
          this.notice({
            type: 'error',
            text: error.message
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    onChangeYear (year) {
      this.year = year
      this.fetchData({
        filter: {
          cycle_year: year,
          cycle_month: this.month
        }
      })
    },
    onChangeMonth (month) {
      this.month = month
      this.fetchData({
        filter: {
          cycle_month: month,
          cycle_year: this.year
        }
      })
    },
    clearEdit () {
      this.showForm = false
    },
    notice (not) {
      this.$Notice[not.type]({
        title: 'MONTHLY OVERTIME',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData({
        filter: {
          cycle_year: vm.year,
          cycle_month: vm.month
        }
      })
    })
  }
}
</script>
